import { render } from "./OldBillingGrid.vue?vue&type=template&id=35c1114c"
import script from "./OldBillingGrid.vue?vue&type=script&lang=js"
export * from "./OldBillingGrid.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__